import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getClinicList() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/sudo/clinicList`;
    return httpGet(apiUrl);
  }

  getClinicStaffRoleList(clinicID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/sudo/staffRoleList?clinicID=${clinicID}`;
    return httpGet(apiUrl);
  }

  tokenEmulator(clinic, staffID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/sudo/tokenEmulator`;
    return httpPost(apiUrl, { clinic, staffID });
  }
}
